var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRejected = function SvgRejected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#63768D",
    d: "m42.24 65.6-40-33.104a4.55 4.55 0 0 1 1.44-1.536L19.2 20.32h57.6l15.52 10.64a4.55 4.55 0 0 1 1.44 1.536l-40 33.104z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rejected_svg__a)",
    d: "M76.656 12.8c.095.206.144.43.144.656V46.4L48 68.8 19.2 46.4V4.8a3.21 3.21 0 0 1 3.2-3.2h42.544c.227 0 .45.05.656.144z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC7361",
    d: "M76.656 12.8H68.8a3.21 3.21 0 0 1-3.2-3.2V1.744q.258.122.464.32l10.272 10.272q.198.206.32.464"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rejected_svg__b)",
    d: "M93.76 32.496 76.8 45.664 53.76 63.552l-1.936-1.472a6.336 6.336 0 0 0-7.648 0l-1.936 1.472L19.2 45.664 2.24 32.496a4.75 4.75 0 0 0-.64 2.384v54.752a4.7 4.7 0 0 0 1.6 3.552A4.73 4.73 0 0 0 6.4 94.4h83.2a4.79 4.79 0 0 0 4.8-4.768V34.88c0-.837-.22-1.66-.64-2.384"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rejected_svg__c)",
    d: "M92.8 93.184a4.73 4.73 0 0 1-3.2 1.216H6.4a4.73 4.73 0 0 1-3.2-1.216l39.04-29.632 1.936-1.472a6.336 6.336 0 0 1 7.648 0l1.936 1.472z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFBFE",
    d: "M48 19.2A14.4 14.4 0 1 0 48 48a14.4 14.4 0 0 0 0-28.8m3.977 23.284a9.44 9.44 0 0 1-5.44 1.03 9.56 9.56 0 0 1-8.45-8.452 9.44 9.44 0 0 1 1.03-5.439.876.876 0 0 1 1.384-.199l11.675 11.675a.877.877 0 0 1-.2 1.385m4.907-4.907a.876.876 0 0 1-1.385.199L43.824 26.101a.875.875 0 0 1 .2-1.385 9.44 9.44 0 0 1 5.438-1.03 9.564 9.564 0 0 1 8.452 8.452 9.44 9.44 0 0 1-1.03 5.439"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "rejected_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(144.417 37.81 32.277)scale(96.3498 84.8009)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AAAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7D3E7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "rejected_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(158.087 36.895 39.815)scale(81.5485 52.5133)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8D3E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rejected_svg__a",
    x1: 48,
    x2: 48,
    y1: -3.589,
    y2: 92.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7878"
  })))));
};
export default SvgRejected;